const ArrowDownward = props => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 21 20"
		fill="none"
		width="21"
		height="20"
		{...props}
	>
		<path
			d="M17.1666 10L15.9916 8.82504L11.3333 13.475V3.33337H9.66658V13.475L5.01659 8.81671L3.83325 10L10.4999 16.6667L17.1666 10Z"
			fill="currentColor"
		/>
	</svg>
);
export default ArrowDownward;
